import { Component, OnInit } from '@angular/core';
import { PassportAdminService } from '../Services/passport.admin.service';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';

@Component({
    selector: "my-package",
    templateUrl: "./overview.component.html",
    styleUrls: ["./overview.component.css", "../passport.component.css"],
    imports: [FormsModule, MatFormField, MatLabel, MatInput]
})
export class OverviewComponent implements OnInit {
  tenantDetails: ITenantDetails;

  constructor(private service: PassportAdminService) {}

  ngOnInit(): void {
    this.service.getTenantDetailsAsync().then((tenant: ITenantDetails) => {
      this.tenantDetails = tenant;
    });
  }
}

export interface ITenantDetails {
  clientId: string;
  clientSecret: string;
}
